export default ['Resty', Resty => Resty('fire_department_plans')];
